/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';

const healthBreakdown = (state) => state.healthBreakdown;

// export const selectHealthSelector = () =>
//   createSelector(
//     healthBreakdown,
//     ({ isLoading, isSuccess, health, lastCacheTime }) => {
//       return {
//         isLoading,
//         isSuccess,
//         health,
//         lastCacheTime,
//       };
//     }
//   );

export const selectHealthSelector = () =>
  createSelector(
    healthBreakdown,
    ({ isLoading, isSuccess, health, healthB, lastCacheTime }) => {
      return {
        isLoading,
        isSuccess,
        health,
        healthB,
        lastCacheTime,
      };
    }
  );
